import { useGetRefundReleaseUser } from 'api-hooks/refund/refund-release-user';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import RefundReleaseUserForm from './components/form';

export type RefundReleaseUserViewParams = {
  id: string;
};

export default function RefundReleaseUserView(
  props: NavigationProps<NavigationRoutes.RefundReleaseUserView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetRefundReleaseUser({
      id,
    });

  const refundReleaseUser = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <RefundReleaseUserForm
            refundReleaseUser={refundReleaseUser}
            {...props}
          />
        </>
      }
    />
  );
}
